/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { MediaResponse } from '../models/media-response';
import { PromptContainer } from '../models/prompt-container';
import { promptsGet } from '../fn/prompts-manager-resource/prompts-get';
import { PromptsGet$Params } from '../fn/prompts-manager-resource/prompts-get';
import { PromptsListResponse } from '../models/prompts-list-response';
import { promptsMediaByPromptGet } from '../fn/prompts-manager-resource/prompts-media-by-prompt-get';
import { PromptsMediaByPromptGet$Params } from '../fn/prompts-manager-resource/prompts-media-by-prompt-get';
import { promptsPromoGet } from '../fn/prompts-manager-resource/prompts-promo-get';
import { PromptsPromoGet$Params } from '../fn/prompts-manager-resource/prompts-promo-get';
import { promptsPromosGet } from '../fn/prompts-manager-resource/prompts-promos-get';
import { PromptsPromosGet$Params } from '../fn/prompts-manager-resource/prompts-promos-get';
import { promptsPromptIdDelete } from '../fn/prompts-manager-resource/prompts-prompt-id-delete';
import { PromptsPromptIdDelete$Params } from '../fn/prompts-manager-resource/prompts-prompt-id-delete';
import { promptsPromptIdGet } from '../fn/prompts-manager-resource/prompts-prompt-id-get';
import { PromptsPromptIdGet$Params } from '../fn/prompts-manager-resource/prompts-prompt-id-get';
import { promptsPromptIdHardDelete } from '../fn/prompts-manager-resource/prompts-prompt-id-hard-delete';
import { PromptsPromptIdHardDelete$Params } from '../fn/prompts-manager-resource/prompts-prompt-id-hard-delete';
import { promptsPromptIdSharePost } from '../fn/prompts-manager-resource/prompts-prompt-id-share-post';
import { PromptsPromptIdSharePost$Params } from '../fn/prompts-manager-resource/prompts-prompt-id-share-post';
import { promptsRandomArtistTagGet } from '../fn/prompts-manager-resource/prompts-random-artist-tag-get';
import { PromptsRandomArtistTagGet$Params } from '../fn/prompts-manager-resource/prompts-random-artist-tag-get';
import { promptsRandomNameGet } from '../fn/prompts-manager-resource/prompts-random-name-get';
import { PromptsRandomNameGet$Params } from '../fn/prompts-manager-resource/prompts-random-name-get';
import { promptsSharedGet } from '../fn/prompts-manager-resource/prompts-shared-get';
import { PromptsSharedGet$Params } from '../fn/prompts-manager-resource/prompts-shared-get';
import { promptsSharedShareSlugGet } from '../fn/prompts-manager-resource/prompts-shared-share-slug-get';
import { PromptsSharedShareSlugGet$Params } from '../fn/prompts-manager-resource/prompts-shared-share-slug-get';
import { RandomNameResponse } from '../models/random-name-response';
import { SharePromptResponse } from '../models/share-prompt-response';

/**
 * Endpoints for managing completed prompts.
 */
@Injectable({ providedIn: 'root' })
export class PromptsManagerResourceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `promptsGet()` */
  static readonly PromptsGetPath = '/prompts';

  /**
   * Get Prompts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `promptsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsGet$Response(
    params: PromptsGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<PromptsListResponse>> {
    const obs = promptsGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get Prompts.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `promptsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsGet(
    params: PromptsGet$Params,
    context?: HttpContext,
  ): Observable<PromptsListResponse> {
    const resp = this.promptsGet$Response(params, context);
    return resp.pipe(
      map(
        (r: StrictHttpResponse<PromptsListResponse>): PromptsListResponse =>
          r.body,
      ),
    );
  }

  /** Path part for operation `promptsMediaByPromptGet()` */
  static readonly PromptsMediaByPromptGetPath = '/prompts/media-by-prompt';

  /**
   * Get Media By Prompt.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `promptsMediaByPromptGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsMediaByPromptGet$Response(
    params: PromptsMediaByPromptGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<MediaResponse>>> {
    const obs = promptsMediaByPromptGet(
      this.http,
      this.rootUrl,
      params,
      context,
    );
    return obs;
  }

  /**
   * Get Media By Prompt.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `promptsMediaByPromptGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsMediaByPromptGet(
    params: PromptsMediaByPromptGet$Params,
    context?: HttpContext,
  ): Observable<Array<MediaResponse>> {
    const resp = this.promptsMediaByPromptGet$Response(params, context);
    return resp.pipe(
      map(
        (r: StrictHttpResponse<Array<MediaResponse>>): Array<MediaResponse> =>
          r.body,
      ),
    );
  }

  /** Path part for operation `promptsPromoGet()` */
  static readonly PromptsPromoGetPath = '/prompts/promo';

  /**
   * Get Promo Examples All.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `promptsPromoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsPromoGet$Response(
    params?: PromptsPromoGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<PromptsListResponse>> {
    const obs = promptsPromoGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get Promo Examples All.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `promptsPromoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsPromoGet(
    params?: PromptsPromoGet$Params,
    context?: HttpContext,
  ): Observable<PromptsListResponse> {
    const resp = this.promptsPromoGet$Response(params, context);
    return resp.pipe(
      map(
        (r: StrictHttpResponse<PromptsListResponse>): PromptsListResponse =>
          r.body,
      ),
    );
  }

  /** Path part for operation `promptsPromosGet()` */
  static readonly PromptsPromosGetPath = '/prompts/promos';

  /**
   * Get Promo Examples.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `promptsPromosGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsPromosGet$Response(
    params: PromptsPromosGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<PromptsListResponse>> {
    const obs = promptsPromosGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get Promo Examples.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `promptsPromosGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsPromosGet(
    params: PromptsPromosGet$Params,
    context?: HttpContext,
  ): Observable<PromptsListResponse> {
    const resp = this.promptsPromosGet$Response(params, context);
    return resp.pipe(
      map(
        (r: StrictHttpResponse<PromptsListResponse>): PromptsListResponse =>
          r.body,
      ),
    );
  }

  /** Path part for operation `promptsRandomArtistTagGet()` */
  static readonly PromptsRandomArtistTagGetPath = '/prompts/randomArtistTag';

  /**
   * Get Random Artist Tag.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `promptsRandomArtistTagGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsRandomArtistTagGet$Response(
    params?: PromptsRandomArtistTagGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<RandomNameResponse>> {
    const obs = promptsRandomArtistTagGet(
      this.http,
      this.rootUrl,
      params,
      context,
    );
    return obs;
  }

  /**
   * Get Random Artist Tag.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `promptsRandomArtistTagGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsRandomArtistTagGet(
    params?: PromptsRandomArtistTagGet$Params,
    context?: HttpContext,
  ): Observable<RandomNameResponse> {
    const resp = this.promptsRandomArtistTagGet$Response(params, context);
    return resp.pipe(
      map(
        (r: StrictHttpResponse<RandomNameResponse>): RandomNameResponse =>
          r.body,
      ),
    );
  }

  /** Path part for operation `promptsRandomNameGet()` */
  static readonly PromptsRandomNameGetPath = '/prompts/randomName';

  /**
   * Get Random Name.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `promptsRandomNameGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsRandomNameGet$Response(
    params?: PromptsRandomNameGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<RandomNameResponse>> {
    const obs = promptsRandomNameGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get Random Name.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `promptsRandomNameGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsRandomNameGet(
    params?: PromptsRandomNameGet$Params,
    context?: HttpContext,
  ): Observable<RandomNameResponse> {
    const resp = this.promptsRandomNameGet$Response(params, context);
    return resp.pipe(
      map(
        (r: StrictHttpResponse<RandomNameResponse>): RandomNameResponse =>
          r.body,
      ),
    );
  }

  /** Path part for operation `promptsSharedGet()` */
  static readonly PromptsSharedGetPath = '/prompts/shared';

  /**
   * Get Shared Prompts.
   *
   * Resolves a list of share slugs to their prompt containers in a single request.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `promptsSharedGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsSharedGet$Response(
    params: PromptsSharedGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<PromptContainer>>> {
    const obs = promptsSharedGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get Shared Prompts.
   *
   * Resolves a list of share slugs to their prompt containers in a single request.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `promptsSharedGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsSharedGet(
    params: PromptsSharedGet$Params,
    context?: HttpContext,
  ): Observable<Array<PromptContainer>> {
    const resp = this.promptsSharedGet$Response(params, context);
    return resp.pipe(
      map(
        (
          r: StrictHttpResponse<Array<PromptContainer>>,
        ): Array<PromptContainer> => r.body,
      ),
    );
  }

  /** Path part for operation `promptsSharedShareSlugGet()` */
  static readonly PromptsSharedShareSlugGetPath = '/prompts/shared/{shareSlug}';

  /**
   * Get Shared Prompt.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `promptsSharedShareSlugGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsSharedShareSlugGet$Response(
    params: PromptsSharedShareSlugGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<PromptContainer>> {
    const obs = promptsSharedShareSlugGet(
      this.http,
      this.rootUrl,
      params,
      context,
    );
    return obs;
  }

  /**
   * Get Shared Prompt.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `promptsSharedShareSlugGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsSharedShareSlugGet(
    params: PromptsSharedShareSlugGet$Params,
    context?: HttpContext,
  ): Observable<PromptContainer> {
    const resp = this.promptsSharedShareSlugGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PromptContainer>): PromptContainer => r.body),
    );
  }

  /** Path part for operation `promptsPromptIdGet()` */
  static readonly PromptsPromptIdGetPath = '/prompts/{promptId}';

  /**
   * Get Prompt.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `promptsPromptIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsPromptIdGet$Response(
    params: PromptsPromptIdGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<PromptContainer>> {
    const obs = promptsPromptIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get Prompt.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `promptsPromptIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsPromptIdGet(
    params: PromptsPromptIdGet$Params,
    context?: HttpContext,
  ): Observable<PromptContainer> {
    const resp = this.promptsPromptIdGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PromptContainer>): PromptContainer => r.body),
    );
  }

  /** Path part for operation `promptsPromptIdDelete()` */
  static readonly PromptsPromptIdDeletePath = '/prompts/{promptId}';

  /**
   * Delete Prompt.
   *
   * Deletes a completed prompt
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `promptsPromptIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsPromptIdDelete$Response(
    params: PromptsPromptIdDelete$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    const obs = promptsPromptIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete Prompt.
   *
   * Deletes a completed prompt
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `promptsPromptIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsPromptIdDelete(
    params: PromptsPromptIdDelete$Params,
    context?: HttpContext,
  ): Observable<void> {
    const resp = this.promptsPromptIdDelete$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `promptsPromptIdHardDelete()` */
  static readonly PromptsPromptIdHardDeletePath = '/prompts/{promptId}/hard';

  /**
   * Hard Delete Prompt.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `promptsPromptIdHardDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsPromptIdHardDelete$Response(
    params: PromptsPromptIdHardDelete$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    const obs = promptsPromptIdHardDelete(
      this.http,
      this.rootUrl,
      params,
      context,
    );
    return obs;
  }

  /**
   * Hard Delete Prompt.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `promptsPromptIdHardDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsPromptIdHardDelete(
    params: PromptsPromptIdHardDelete$Params,
    context?: HttpContext,
  ): Observable<void> {
    const resp = this.promptsPromptIdHardDelete$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `promptsPromptIdSharePost()` */
  static readonly PromptsPromptIdSharePostPath = '/prompts/{promptId}/share';

  /**
   * Share Prompt.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `promptsPromptIdSharePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsPromptIdSharePost$Response(
    params: PromptsPromptIdSharePost$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<SharePromptResponse>> {
    const obs = promptsPromptIdSharePost(
      this.http,
      this.rootUrl,
      params,
      context,
    );
    return obs;
  }

  /**
   * Share Prompt.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `promptsPromptIdSharePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  promptsPromptIdSharePost(
    params: PromptsPromptIdSharePost$Params,
    context?: HttpContext,
  ): Observable<SharePromptResponse> {
    const resp = this.promptsPromptIdSharePost$Response(params, context);
    return resp.pipe(
      map(
        (r: StrictHttpResponse<SharePromptResponse>): SharePromptResponse =>
          r.body,
      ),
    );
  }
}
